import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import CardLayout from '@/layouts/CardLayout.vue';
import Background from '@/components/Background.vue';
import Next from '@/components/Next.vue';
import ActionList from '@/components/ActionList.vue';
import CategoryIcon from '@/components/CategoryIcon.vue';
import Thumbnail from '@/components/Thumbnail.vue';
import MiniCart from '@/components/MiniCart.vue';
import SpinnerHolder from '@/components/SpinnerHolder.vue';
import CommonHeader from '@/components/CommonHeader.vue';
import { localizedProductPrice } from '../mixins/MenuLocalization';
import VariableLogo from '@/components/VariableLogo.vue';
import { MainView } from '@/store/state';
let Menu = class Menu extends Vue {
    constructor() {
        super(...arguments);
        this.categories = [];
        this.products = [];
        this.localizations = this.$store.state.menu ? this.$store.state.menu.localizations : [];
    }
    seeMoreCategories() {
        this.$router.push('/categories');
    }
    seeCategory(category) {
        if (category.subcategories.length > 0) {
            this.$store.dispatch('setCategoryId', category.id);
            this.$router.push('/subcategories');
        }
        else {
            this.$router.push('/categories/' + category.id);
        }
    }
    seeProduct(product) {
        this.$store.dispatch('setCategoryId', product.categoryId);
        this.$router.push('/products/' + product.id);
    }
    getMostSelledProducts() {
        if (this.$store.getters.showMostSelled) {
            const products = this.$store.getters.products;
            return products
                .filter((p) => p.mostSelled && localizedProductPrice(p))
                .sort((c, n) => c.mostSelledPriority - n.mostSelledPriority);
        }
        return this.products;
    }
    getHomeCategories() {
        const categories = this.$store.getters.categories;
        return categories.filter((c) => c.showsAtHome).sort((c, n) => c.showsAtHomePriority - n.showsAtHomePriority);
    }
    async created() {
        await this.$store.dispatch('setMainView', MainView.MENU);
        this.categories = this.getHomeCategories();
        this.products = this.getMostSelledProducts();
    }
};
Menu = __decorate([
    Component({
        components: {
            Background,
            VariableLogo,
            CardLayout,
            Next,
            ActionList,
            CategoryIcon,
            Thumbnail,
            SpinnerHolder,
            CommonHeader,
            MiniCart,
        },
    })
], Menu);
export default Menu;
